// useMapData — TanStack Query wrapper for GET /api/map-data.
//
// Plan 08-01 contract:
// - queryKey = ['map-data']
// - staleTime = 30_000 (matches the dashboard's /api/rankings stale window)
// - AbortController-cancellable via the queryFn signal
// - No polling — amenity + property data only changes on admin refresh
//   or new submission, not during a single map session

import { useQuery } from '@tanstack/react-query';
import { fetchMapData } from '@/lib/api';
import type { MapDataResponse } from '@/types/db';

export function useMapData() {
  return useQuery<MapDataResponse>({
    queryKey: ['map-data'],
    queryFn: ({ signal }) => fetchMapData(signal),
    staleTime: 30_000,
  });
}
